import React from 'react';
import { useLocation } from 'react-router-dom';
import './MobileFooter.css';

const MobileFooter = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { path: '/', icon: '/character-quiz-and-any-related.png', fallbackIcon: '🎮', label: 'Quiz' },
    { path: '/characters', icon: 'https://cdn.myanimelist.net/images/characters/9/307639.jpg', fallbackIcon: '⚓', label: 'Archive', circle: true },
    { path: '/leaderboard', icon: '/leaderboard-icon.png', fallbackIcon: '🏆', label: 'Ranks' },
    { path: '/profile', icon: '/profile-icon.png', fallbackIcon: '👤', label: 'Profile' },
  ];

  return (
    <footer className="mobile-footer">
      {/* Main Navigation */}
      <nav className="mobile-nav">
        {navItems.map((item) => (
          <a
            key={item.path}
            href={item.path}
            className={`mobile-nav-item ${currentPath === item.path ? 'active' : ''}`}
          >
            <div className="nav-icon-wrapper">
              {item.icon ? (
                <img
                  src={item.icon}
                  alt=""
                  className={`nav-icon-img${item.circle ? ' nav-icon-circle' : ''}`}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
              ) : null}
              <span className="nav-icon-fallback" style={{ display: item.icon ? 'none' : 'block' }}>
                {item.fallbackIcon}
              </span>
            </div>
            <span className="nav-label">{item.label}</span>
            {currentPath === item.path && <div className="active-indicator" />}
          </a>
        ))}
      </nav>

      {/* Mini Legal Bar */}
      <div className="mobile-legal-mini">
        <a href="/privacy">Privacy</a>
        <span>•</span>
        <a href="/terms">Terms</a>
        <span>•</span>
        <a href="/about">About</a>
      </div>

      {/* The desktop footer carried a disclaimer and the phone carried none,
          which is backwards: most of the traffic is on a phone. */}
      <p className="mobile-disclaimer">
        Unofficial fan site &middot; not affiliated with Eiichiro Oda, Shueisha or Toei
        Animation. One Piece and its characters belong to their owners.
        &copy; {new Date().getFullYear()} ChibiDash
      </p>
    </footer>
  );
};

export default MobileFooter;
